




























import { defineComponent }       from '@vue/composition-api';
import cTable                    from '@/components/table/table.component.vue';
import cRowActions               from '@/components/row-actions/row-actions.component.vue';
import { useGroupQuotationList } from '@/views/group-quotation-list/hooks/use-group-quotation-list.hook';

export default defineComponent({
  name: 'cGroupQuotationListTable',
  components: {
    cTable,
    cRowActions,
  },
  setup() {
    const { tableColumns, tableData, loading, onEditAction } = useGroupQuotationList();

    return {
      tableColumns,
      tableData,
      loading,
      onEditAction,
    };
  },
});
